<template>
	<div class="temd">
		<div class="swiperD">
			<div class="swiper-container" :style="{height:swiperH+'px'}">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="sw in swiperArr">
						<img @click="seeInfo(sw)" :src="imageUrl+sw.pic" />
					</div>
				</div>
				<!-- Add Pagination -->
				<div class="swiper-pagination zkszz"></div>
				<!-- Add Arrows -->
				<div class="swiper-button-next"></div>
				<div class="swiper-button-prev"></div>
			</div>
			<!--<div class="swiperDes">
				<div v-for="sw,index in swiperArr" class="swiperDes_item" :class="evaluateDialogIndex===index?'evaluateDialog':''" @click="changeSwiperIndex(index)">{{sw.title}}</div>
			</div>-->
		</div>
		<img style="width: 100%;" src="../../assets/007.png"/>
		<div class="designCase">
			<!--<div class="title">设计案例</div>-->
			<div class="designCase_arr">
				<!--<div class="masonry">
					<div class="item" v-if="loading" v-for="ai,index in anliArr" @click="seePhoto(ai)">
						<div class="item_content content-lar">
							<img :src="imgAPI+ai.imgUrlArr[0]" />
							<div class="userInfo">
								<div class="usphoto" @click="usersWorks(ai)">
									<img :src="ai.headimg?imgAPI+ai.headimg:require('../../../public/icon/001.jpg')"  />
								</div>
								<div class="usname">{{ai.nickname}}</div>
							</div>
						</div>
					</div>
				</div>-->

				<div class="anliList" style="display: flex;flex-direction: row;flex-wrap: wrap;width: 90%;margin: auto;">
					<div class="anliList_item" v-if="loading" v-for="ai,index in anliArr" @click="seePhoto(ai)" style="width: 20%;border: 5px solid #f2f2f2;box-sizing: border-box;">
						<div class="anliList_itemImg">
							<img :src="imgAPI+ai.imgUrlArr[0]" style="width: 100%;" />
							<div class="userInfo">
								<div class="usphoto" @click="usersWorks(ai)" style="">
									<img :src="ai.headimg?imgAPI+ai.headimg:require('../../../public/icon/001.jpg')" style="width: 100%;" />
								</div>
								<div class="usname">{{ai.nickname}}</div>
							</div>
						</div>
					</div>
				</div>

				<div class="seemoreDe" v-if="loading">
					<span v-if="pTotla>20" style="cursor: pointer;" @click="seeWorks_more">查看更多</span>
					<span v-if="pTotla<21">没有更多了</span>
				</div>
			</div>
		</div>
		<div class="designCase">
			<!--<div class="title">设计师</div>-->
			<div class="bgTit" style="position: relative;">
				<img src="../../assets/005.png"/>
				<div class="ttitt">设&nbsp;计&nbsp;师</div>
			</div>
			<div class="designTeam_arr">
				<div class="designTeam_arr_item" v-for="ai in des_team">
					<div class="userPotot" @click="usersWorks(ai)">
						<img :src="ai.headimg?imgAPI+ai.headimg:require('../../../public/icon/001.jpg')" />
					</div>
					<div class="userName">{{ai.nickname}}</div>
				</div>
			</div>
		</div>
		<div class="designCase">
			<!--<div class="title">设计机构</div>-->
			<div class="bgTit" style="position: relative;">
				<img src="../../assets/005.png"/>
				<div class="ttitt" style="padding-left: 76px;">设&nbsp;计&nbsp;机&nbsp;构</div>
			</div>
			<div class="designTeam_arr">
				<div class="designTeam_arr_item" v-for="ai in jigoudataList">
					<div class="userPotot"  @click="seePhotoJigou(ai)" >
						<img :src="ai.headimg?imgAPI+ai.headimg:require('../../../public/icon/001.jpg')" />
					</div>
					<div class="userName">{{ai.nickname?ai.nickname:ai.name}}</div>
				</div>
				<img style="display: block;margin:30px auto;width: 200px;" v-if="jigoudataList.length<1" src="../../../public/img/74ebae016998d5fae28c89076ff97744.png"/>
			</div>
		</div>
		<div class="designCase">
			<!--<div class="title">专家团队</div>-->
			<div class="bgTit" style="position: relative;">
				<img src="../../assets/005.png"/>
				<div class="ttitt" style="padding-left: 76px;">专&nbsp;家&nbsp;团&nbsp;队</div>
			</div>
			<div class="designTeam_arr">
				<div class="designTeam_arr_item" v-for="ai in desZJ_team">
					<div class="userPotot" @click="usersWorks(ai)">
						<img :src="ai.headimg?imgAPI+ai.headimg:require('../../../public/icon/001.jpg')" />
					</div>
					<div class="userName">{{ai.nickname?ai.nickname:ai.name}}</div>
				</div>
			</div>
		</div>
		<div class="designCase">
			<div class="hyfh">
				<div class="hyfh_left">
					<div class="title">新闻资讯</div>
					<div class="hyfh_left_content">
						<ul>
							<li v-for="ii in newsAndInformationArr" @click="seeInfo(ii,5)">{{ii.title}}</li>
						</ul>
					</div>
				</div>
				<div class="hyfh_right">
					<div class="title">概念孵化</div>
					<div class="hyfh_left_content">
						<ul>
							<li v-for="ci in conceptIncubationArr" @click="seeInfo(ci,1)">{{ci.title}}</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="" :show-close="false" :visible.sync="seePhotoDlog" class="myDlog myDlog_opa" :fullscreen="true">
			<worksInfoDlog :pageParams="pageParams" v-on:parentMethod="communication" v-if="seePhotoDlog"></worksInfoDlog>
		</el-dialog>
	</div>
</template>

<script>
	import "../../assets/js/swiper.min.js"
	import baseConst from '../../assets/js/baseConst.js' //注意路
	const worksInfoDlog = () =>
		import("@/components/home/works/works_info.vue"); //作品详情
	export default {
		components: {
			worksInfoDlog
		},
		data() {
			return {
				imageUrl:'http://www.1522znsj.com',
				swiper_1: {},
				evaluateDialogIndex: 0,
				anliArr: [],
				seePhotoDlog: false, //作品详情
				seePhotoImage: '',
				seePhotoUname: '',
				swiperH: 0,
				swiperArr: [],
				newsAndInformationArr: [], //新闻咨询
				conceptIncubationArr: [], //项目孵化
				des_team: [],
				imgAPI: '',
				loading: false,
				pageParams: {}, //页面传参参数
				pTotla: 0,
				desZJ_team: [],
				jigoudataList:[],
			}
		},
		created: function() {
			let _this = this;
			_this.imgAPI = baseConst.IMG_API;
			_this.getSwiperData_api();
			_this.getIndustryInformation_api();
			_this.getConceptIncubation_api();
			_this.getDesign_team();
			_this.getDesign_teamByZJ();
			_this.getDesignLise();
			_this.getDesignJigou();
		},
		mounted: function() {
			let _this = this;
			let offsetWidth = document.documentElement.clientWidth / 3;
			_this.swiperH = offsetWidth;
			/*监听浏览器窗口大小变化
			 创建于2019-11-22  作者：郑凯*/
			window.onresize = function() {
				let offsetWidth = document.documentElement.clientWidth / 3;
				_this.swiperH = offsetWidth;
			}
			setTimeout(function() {
				_this.initSwiper()
			}, 500)
		},
		methods: {
			/**  * -----查看图片
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			seePhoto(obj) {
				let _this = this;
				_this.pageParams = JSON.parse(JSON.stringify(obj));
				_this.seePhotoDlog = true;
				setTimeout(function() {
					document.getElementsByClassName("el-dialog__body")[0].scrollTop = 0;
				}, 100)
			},
			/**  * -----初始化swiper    
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			initSwiper() {
				let _this = this;
				_this.swiper_1 = new Swiper('.swiper-container', {
					loop: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true,
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					on: {
						slideChangeTransitionEnd: function() {　　　
							let index = this.realIndex;
							_this.evaluateDialogIndex = index;
						}
					},
				});
			},
			/**  * -----切换swiper    
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			changeSwiperIndex(index) {
				let _this = this;
				_this.evaluateDialogIndex = index;
				_this.swiper_1.slideTo(index, 500, false); //切换到第一个slide，速度为1秒
				switch(index) {
					case 1:

						break;
				}
			},
			/*获取轮播图片
			 创建于2019-11-22  作者：郑凯*/
			getSwiperData_api() {
				let _this = this;
				let paramsObj = this.$qs.stringify({});
				_this.$axios({
					method: 'get',
					url: '/api/indexData',
					headers: {},
					data: paramsObj
				}).then((response) => {
					let resObj = response.data;
					//console.log(JSON.stringify(resObj)) //请求成功返回的数据
					if(resObj.status == '00') {
						_this.swiperArr = resObj.data;
					} else if(resObj.status == 1001) {

					}
				}).catch((error) => {
					return false;
				});
			},
			/*获取底部行业资讯
			 创建于2019-11-25  作者：郑凯*/
			getIndustryInformation_api() {
				let _this = this;
				let paramsObj = {
					"pageNumber": 1,
					"limit5": 5,
					"class_id": 5
				};
				_this.$axios({
					method: 'get',
					url: '/api/getContentListByClassId',
					headers: {},
					params: paramsObj
				}).then((response) => {
					let resObj = response.data;
					//console.log(JSON.stringify(resObj)) //请求成功返回的数据
					if(resObj.status == '00') {
						_this.newsAndInformationArr = resObj.data.data;
					} else if(resObj.status == 1001) {

					}
				}).catch((error) => {
					return false;
				});
			},
			/*获取底部概念孵化
			 创建于2019-11-25  作者：郑凯*/
			getConceptIncubation_api() {
				let _this = this;
				let paramsObj = {
					"pageNumber": 1,
					"limit5": 5,
					"class_id": 1
				};
				_this.$axios({
					method: 'get',
					url: '/api/getContentListByClassId',
					headers: {},
					params: paramsObj
				}).then((response) => {
					let resObj = response.data;
					//console.log(JSON.stringify(resObj)) //请求成功返回的数据
					if(resObj.status == '00') {
						_this.conceptIncubationArr = resObj.data.data;
					} else if(resObj.status == 1001) {

					}
				}).catch((error) => {
					return false;
				});
			},
			/**  * -----查看详情
			 * @version 1.0  * @author 您的大名 2019年11月21日  * */
			seeInfo(obj, type) {
				let _this = this;
				if(type) {
					obj.type = type;
				}
				const {
					href
				} = this.$router.resolve({
					path: '/twoLevelPage',
					query: {
						content_id: obj.content_id,
						type: obj.type
					}
				})
				window.open(href, '_blank')
			},
			/*获取设计案例
			 创建于2019-11-25  作者：郑凯*/
			getDesignLise() {
				let _this = this;
				let params = {
					limit: 20,
					pageNumber: 1
				};
				_this.getApi('/api/getDesignWorksList', params)
					.then((res) => {
						//console.log(res)
						if(res.status == '00') {
							_this.anliArr = res.data.data;
							_this.pTotla = res.data.total;
							for(let i = 0; i < _this.anliArr.length; i++) {
								let imgUrlArr = [];
								imgUrlArr = _this.anliArr[i].works.split('|');
								_this.anliArr[i].imgUrlArr = imgUrlArr;
							}
							_this.loading = true;
							let offsetWidth = document.documentElement.clientWidth / 3;
							_this.swiperH = offsetWidth;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/*获取设计团队
			 创建于2019-11-25  作者：郑凯*/
			getDesign_team() {
				let _this = this;
				let params = {
					limit: 20
				};
				_this.getApi('/api/getDesignGroupList', params)
					.then((res) => {
						console.log(res)
						if(res.status == '00') {
							_this.des_team = res.data;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/*获取专家设计团队
			 创建于2019-11-25  作者：郑凯*/
			getDesign_teamByZJ() {
				let _this = this;
				let params = {
					limit: 20
				};
				_this.getApi('/api/getExperts', params)
					.then((res) => {
						console.log(JSON.stringify(res))
						if(res.status == '00') {
							_this.desZJ_team = res.data;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			/*查看多多案例
			 创建于2019-11-25  作者：郑凯*/
			seeWorks_more() {
				let _this = this;
				_this.$router.push('works_more');
			},
			/*查看设计师的作品
			 创建于2019-11-25  作者：郑凯*/
			usersWorks(ob) {
				let _this = this;
				_this.$router.push({
					name: 'works_user',
					query: {
						pagePrams: JSON.stringify(ob)
					}
				})
			},
			/**  * -----这个组件的子组件通信处理    
			 * @version 1.0  * @author 您的大名 2019年12月2日  * */
			communication(type) {
				let _this = this;
				switch(type) {
					case 'works_info':
						_this.seePhotoDlog = false;
						break;
					default:
				}
			},
			
			/*获取设计机构
			 创建于2019-11-25  作者：郑凯*/
			getDesignJigou() {
				let _this = this;
				let apiUrl = '/api/getDesignOrg';
				let params = {
					limit: 2000,
					pageNumber: 1
				};
				_this.getApi(apiUrl, params)
					.then((res) => {
						//console.log(res)
						if(res.status == '00') {
							_this.jigoudataList = res.data;
						} else {
							_this.$message.error(res.message);
							return;
						}
					})
					.catch((err) => {})
			},
			seePhotoJigou(ob){
				let _this = this;
				_this.$router.push({
						name: 'disgnJigou',
						　　　　query: {
							pagePrams: JSON.stringify(ob)
						}
					})
			}
		}
	}
</script>

<style scoped>
	html, body{ position: relative; height: 100%;}
	body{ background: #eee; font-family: Helvetica Neue, Helvetica, Arial, sans-serif; font-size: 14px; color: #000; margin: 0; padding: 0;}
	.swiper-container{ width: 100%; height: 500px; position: relative;}
	.swiper-slide{ text-align: center; font-size: 18px; background: #fff;
		/* Center slide text vertically */
		display: -webkit-box; display: -ms-flexbox; display: -webkit-flex; display: flex; -webkit-box-pack: center; -ms-flex-pack: center; -webkit-justify-content: center; justify-content: center; -webkit-box-align: center; -ms-flex-align: center; -webkit-align-items: center; align-items: center;}
	.swiper-slide img{ width: 100%; cursor: pointer;height: 100%;}
	.swiper-pagination-bullet{ width: 20px; height: 20px; text-align: center; line-height: 20px; font-size: 12px; color: #000; opacity: 1; background: rgba(0, 0, 0, 0.2);}
	.swiper-pagination-bullet-evaluateDialog{ color: #fff; background: #007aff;}
	.swiperD{ position: relative;}
	.swiperDes{ background-color: rgba(204, 204, 204, 0.6);
		/*opacity: 0.7;*/
		height: 100px; position: absolute; z-index: 99; bottom: 0; display: flex; flex-direction: row; width: 100%;}
	.swiperDes .swiperDes_item{ color: #000; flex: 1; height: 100%; text-align: center; padding: 0 40px; display: flex; align-items: center; position: relative; cursor: pointer;}
	.swiperDes .swiperDes_item::after{ content: ''; position: absolute; width: 1px; height: 80%; background-color: #fff; right: 1px;}
	.swiperDes .swiperDes_item.evaluateDialog{
		/*color: #9C98F4;*/
		color: blue;}
	.title{ width: 140px; height: 70px; line-height: 70px; font-size: 18px;/*padding-left:40px;*/
		text-align: center; background-image: url(../../../public/icon/001.png); background-size: cover; background-repeat: no-repeat; background-position: center; margin-left: 20px; font-weight: bold;color: #fff;}
	.masonry{ -moz-column-count: 5;
		/* Firefox */
		-webkit-column-count: 5;
		/* Safari 和 Chrome */
		column-count: 5; -moz-column-gap: 0.5em; -webkit-column-gap: 0.5em; column-gap: 0.5em; width: 90%; margin: 0.1em auto; padding-bottom: 1rem;}
	.item{ margin-bottom: 1em; -moz-page-break-inside: avoid; -webkit-column-break-inside: avoid; break-inside: avoid;
		/*background: #f60;*/
		background-color: rgb(220, 220, 220); cursor: pointer;}
	.masonry .item:hover{ box-shadow: 0px 0px 5px #ccc; transform: scale(1.03);}
	.item_content img{ width: 100%; display: block;}
	@media screen and (max-width: 800px){ .masonry{ column-count: 5;}
		}
	@media screen and (max-width: 500px){ .masonry{ column-count: 5;}
		}
	.designTeam_arr{ width: 90%; margin: auto; display: flex; flex-direction: row; flex-wrap: wrap;}
	.designTeam_arr .designTeam_arr_item{ width: 20%;}
	.userPotot{ width: 150px; height: 150px; border-radius: 50%; margin: auto; overflow: hidden; cursor: pointer;}
	.userPotot img{ width: 100%;}
	.userName{ text-align: center; padding: 20px 0; padding-bottom: 30px; font-weight: bold;}
	.hyfh{ width: 90%; margin: auto; display: flex; flex-direction: row; padding-bottom: 50px;}
	.hyfh .hyfh_left{ width: 50%;}
	.hyfh .hyfh_right{ width: 50%;}
	.hyfh_left_content{ margin-left: 50px; border-left: 2px solid rgb(101, 165, 153);}
	.hyfh_left_content ul{ width: 90%;}
	.hyfh_left_content ul li{ width: 100%; word-wrap: break-word; font-size: 15px; padding: 8px 0; cursor: pointer;}
	.hyfh_left_content ul li:hover{ color: blue;}
	.userInfo{ width: 100%; display: flex; flex-direction: row; padding: 10px;}
	.usphoto{ width: 40px; height: 40px; border-radius: 50%; background-color: #fff; overflow: hidden;}
	.usname{ display: flex; align-items: center; padding-left: 15px;}
	.imgD{ width: 70%; min-height: 100px; margin: auto; display: flex; flex-direction: row;}
	.imgD .imgD_left{ width: 70%; box-shadow: 0 0 8px #ccc; padding: 15px; background-color: #fff;}
	.imgD .imgD_left img{ width: 100%;}
	.imgD .imgD_right{ flex: 1; margin-left: 20px;}
	.photoTime{ background-color: #fff; box-shadow: 0 0 8px #ccc; padding: 5px;}
	.uutime{ padding: 5px 0; color: #ccc; margin-top: 8px;}
	.myDlog .el-dialog__wrapper{ background-color: rgba(255, 255, 255, 0.8);}
	.seemoreDe{ height: 3rem; text-align: center; font-size: 20px; line-height: 3rem; margin-top: 20px;}
	.anliList_item{ cursor: pointer;}
	.anliList_item:hover{ transform: scale(1.03);box-shadow: 0px 0px 5px #ccc;}
	.swiperD{ position: relative;}
	.swiperD::after{ content: ''; position: absolute; height: 100%; left: 0; top: 0; width: 80px; background-color: rgba(255, 255, 255, 0.3); z-index: 9999;}
	.swiperD::before{ content: ''; position: absolute; height: 100%; right: 0; top: 0; width: 80px; background-color: rgba(255, 255, 255, 0.3); z-index: 9999;}
	.swiper-button-next, .swiper-container-rtl .swiper-button-prev{ right: 90px;background-color: rgba(0,0,0,0.6);width: 50px;height: 50px;border-radius: 50%;background-size: 15px; }
	.swiper-button-prev, .swiper-container-rtl .swiper-button-next{left: 90px;background-color: rgba(0,0,0,0.6);width: 50px;height: 50px;border-radius: 50%;background-size: 15px;}
	
	.bgTit{ width: 752px;margin-bottom: 12px;margin-left: 50px; }
	.bgTit img{ width: 100%; }
	.ttitt{ position: absolute;left: 0;top: 0; color: #fff; width: 100%;height: 100%;padding-left: 87px;font-size: 20px;padding-top: 17px;}
</style>
<style type="text/css">
	.myDlog{ align-items: center;}
	.myDlog .el-dialog{ display: flex; flex-direction: column; margin: 0 !important; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
		/*height:600px;*/
		/*max-height: calc(100% - 30px);
		max-width: calc(100% - 30px);*/
		background: rgba(255, 255, 255, 0.9);}
	.myDlog .el-dialog .el-dialog__body{ flex: 1; overflow: auto;}
	.myDlog .el-dialog .el-dialog__headerbtn{ width: 60px; height: 60px; font-size: 50px;}
	.myDlog_opa.el-dialog__wrapper{ background-color: rgba(255, 255, 255, 0.9)!important;}

	.swiper-container-horizontal>.zkszz.swiper-pagination-bullets .swiper-pagination-bullet{margin: 0;}
	.zkszz .swiper-pagination-bullet{border-radius: none;width:80px;border-radius: 0;}
</style>